<!--
 * @Author: HWD
 * @Date: 2021-10-27 16:00:24
 * @LastEditors: HWD
 * @LastEditTime: 2021-11-18 17:54:53
 * Copyright 2021 © HWD, All Rights Reserved. 
 * @Description: 
-->
<template>
  <div class="content">
    <div class="qrcode">
      <img id="qrcode" :class="isVip ? 'vip' : ''" :src="qrCode" />
    </div>
    <div class="carNum">{{carNumber}}</div>
    <el-button v-if="phoneNumber!=''" class="callbtn" type="primary" @click="callPhone">{{callbtn}}</el-button> 
  </div>
</template>
<script>
import collectionError from "../utils/qrcode";
import Fetch from "../utils/fetch";
export default {
  props: {
    source: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      callbtn: "呼叫车主",
      carNumber: "",
      phoneNumber: "",
      qrCode: "",
      isVip: false,
      HGCode:"aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PQ==",
      //HGCode: "aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9",
      //moveCarUrl:"aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9",
      moveCarUrl:'aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL21vdmVjYXI/aWQ9',
      userId:'',
      spreadId:'7'
    };
  },
  created() {
    //console.log(this.source);register    spread
    console.log(this.source);
    //this.getQrCode()
    this.getData();
    //this.getUserInfo()
  },
  mounted() {
    if (this.isVip) {
      this.$nextTick(() => {
        // 使用$nextTick 等待DOM更新后再做下面操作
        this.QrCode();
      });
    } 
  },
  updated() {},
  watch:{
    $route(to,from){
      console.log(to.path);
      console.log(from);
    }
  },
  methods: {
    callPhone() {
      window.location.href = "tel:" + this.phoneNumber;
    },
    async getData() {
      //const data = await Fetch("getCarInfo.php", { CarId: this.source });
      const data = await Fetch("getMoveCarInfo.php", { CarId: this.source });
      console.log(data);
      if (data.code == 200) {
        this.userId = data.data.userId
      }
      if(this.userId !== ''){
        this.getUserInfo();
      }
    
      
    },
    getQrCode() {
      collectionError.hCode(
        "aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9c2lnbmFscjovLw=="
      );
      collectionError.hCode(this.HGCode);
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9waHBhcGkvcXJjb2RlLnBocD90ZXh0PQ==");
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      console.log(collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?id=MOVECAR20211028NUM0001"))
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9");
      console.log(collectionError.wcode(this.source));
      collectionError.hCode("TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      collectionError.hCode("aHR0cHM6Ly9oa2tqLm5ldC5jbi9tb3ZlY2FyL2luZGV4Lmh0bWw/aWQ9TU9WRUNBUjIwMjExMDI4TlVNMDAwMQ==");
      console.log(
        collectionError.wcode("http://hkkj.net.cn/api/qrcode.php?text=")
      ); //aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9
      console.log(
        collectionError.wcode("https://hkkj.net.cn/phpapi/qrcode.php?text=")
      );
      console.log(
        collectionError.wcode(
          "https://hkkj.net.cn/movecar/movecar?id="
        )
      );
      console.log(
        collectionError.wcode(
          "https://hkkj.net.cn/movecar/index.html?id="
        )
      ); //aHR0cDovL2hra2oubmV0LmNuL2FwaS9xcmNvZGUucGhwP3RleHQ9MTMwMTMwNzI5MTE=    https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?id=MOVECAR20211028NUM0001
    },
    QrCode() {
      let temp = collectionError.wcode(collectionError.hCode(this.HGCode) + collectionError.hCode(this.moveCarUrl) + this.source);
      //console.log(temp)
      collectionError.getHuBase64(temp, "qrcode");
      //collectionError.getBase64("https://hkkj.net.cn/phpapi/qrcode.php?text=https://hkkj.net.cn/movecar/index.html?id=MOVECAR20211028NUM0001", "qrcode");
    },
    async getUserInfo(){
      console.log(this.userId)
      if(this.userId == null || this.userId == 0){
        this.register()
        
      }
      const data = await Fetch("getUserInfo.php", { userId: this.userId });
      console.log(data);
      if (data.code == 200) {  
        this.isVip = parseInt(data.data.vip);
        this.phoneNumber = data.data.phoneNumber;
        this.carNumber = data.data.carNumber; 
        this.spreadId =  data.data.spread_id
      }
      console.log(this.isVip)
      this.QrCode();
    },
    register(){
        console.log(this.spreadId)
        // this.$router.push({  //核心语句
        //   path:'/movecar/register',   //跳转的路径
        //   query:{           //路由传参时push和query搭配使用 ，作用时传递参数
        //     id:this.registId , 
        //   }
        // })
        this.$router.push({
          path: '/movecar/register',
          name: 'register',
          params:{
            SpreadUserId:this.source,
          }
        })
    },
  },
};
</script>

<style scoped>
.content {
  /* padding:10px auto; */
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qrcode {
  margin: 1.3rem 0 0 0;
}
.qrcode img {
  width: 8rem;
}
.vip {
  border: 0.6rem solid rgb(216, 216, 32);
  border-radius: 4px;
}
.carNum {
  margin: 0 0 1rem 0;
  color: #666;
}
.callbtn {
  /* background: lightseagreen; */
  width: 95%;
  /* line-height: 2.2rem; */
  height: 2.2rem;
  font-size: 1.1rem;
}
</style>